import { DATE_FORMAT } from "helpers/common";
import React from "react";

const capitalize = (str) => {
  if (!str) return "--";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const Columns = () => [
  {
    dataField: "jobId",
    text: "Job Id",
    formatter: (_, row) => <span>{row?.jobId || "--"}</span>,
  },
  {
    dataField: "type",
    text: "Type",
    formatter: (_, row) => <span>{capitalize(row?.type)}</span>,
  },
  {
    dataField: "format",
    text: "File Type",
    formatter: (_, row) => <span>{capitalize(row?.format)}</span>,
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (_, row) => <span>{capitalize(row?.status)}</span>,
  },
  {
    dataField: "statusChangeDate",
    text: "Status Change Date",
    formatter: (_, row) => (
      <span>
        {row?.statusChangeDate ? DATE_FORMAT(row.statusChangeDate) : "--"}
      </span>
    ),
  },
  {
    dataField: "expiryAt",
    text: "Expiry Time",
    formatter: (_, row) => (
      <span>{row?.expireAt ? DATE_FORMAT(row.expireAt) : "--"}</span>
    ),
  },
  {
    dataField: "url",
    text: "Download",
    formatter: (_, row) => {
      const isAvailable = !!row?.signedUrl;
      return (
        <button
          className={`btn btn-${isAvailable ? "dark" : "light"} btn-sm`}
          disabled={!isAvailable}
          onClick={() => isAvailable && window.open(row.signedUrl, "_blank")}
          title={isAvailable ? "Download file" : "File not available"}
        >
          {/* Using Font Awesome download icon */}
          <i className="fas fa-download"></i>
        </button>
      );
    },
  },
];

export default Columns;
